import React, { useCallback, useRef, useState } from 'react';
import { Button, Icon } from '@blueprintjs/core';
import { useCanTransferApplication } from '../../hooks/utils/useCanTransferApplication';
import { TransferApplicationDialog } from './TransferApplicationDialog';

interface TransferButtonProps {
  applicationId: string;
  applicationOwnerId?: string;
  marketCountry: string;
  assignmentType: string;
}

export const TransferButton: React.FC<TransferButtonProps> = ({
  applicationId,
  applicationOwnerId,
  marketCountry,
  assignmentType,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const canTransfer = useCanTransferApplication({
    applicationOwnerId,
  });

  const onCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
    // Return focus to button for accessibility
    setTimeout(() => buttonRef.current?.focus(), 0);
  }, []);

  const onOpenDialog = useCallback(() => {
    setIsDialogOpen(true);
  }, []);

  if (!canTransfer) return null;

  return (
    <>
      <Button
        ref={buttonRef}
        variant="minimal"
        size="small"
        icon={<Icon icon="swap-horizontal" />}
        aria-label={`Transfer application ${applicationId} to another operator`}
        onClick={onOpenDialog}
      />

      <TransferApplicationDialog
        isOpen={isDialogOpen}
        onClose={onCloseDialog}
        applicationId={applicationId}
        currentOwnerId={applicationOwnerId}
        marketCountry={marketCountry}
        assignmentType={assignmentType}
      />
    </>
  );
};
